import * as API from "./api"
import { fetchDataAndProceed } from "../../utils/dataUtility"
import {
  UPDATE_DASHBOARD_STATE,
  DASHBOARD_MAKE_SOCKET_CONNECTION,
  DASHBOARD_SOCKET_DISCONNECT,
  EMIT_DASHBOARD_CUSTOM_EVENT,
  CALL_DASHBOARD_SOCKET_METHOD,
  UPDATE_ANALYSIS_DATA,
} from "./actiontypes"
import { METHOD_TYPES } from "../../constants/common"

export const updateDashboardState = payload => {
  return {
    type: UPDATE_DASHBOARD_STATE,
    payload,
  }
}

export const makeDashboardSocketConnection = host => {
  return {
    type: DASHBOARD_MAKE_SOCKET_CONNECTION,
    host,
  }
}

export const callDashboardSocketMethod = payload => {
  return {
    type: CALL_DASHBOARD_SOCKET_METHOD,
    payload,
  }
}

export const dashboardSocketDisconnect = () => {
  return {
    type: DASHBOARD_SOCKET_DISCONNECT,
  }
}

export const emitDashboardCustomEvent = (event, payload, callback) => {
  return {
    type: EMIT_DASHBOARD_CUSTOM_EVENT,
    event,
    payload,
    callback,
  }
}

export const getFrequentAnalysisData = data => dispatch => {
  fetchDataAndProceed(
    {
      url: API.getFrequentData,
      method: METHOD_TYPES.POST,
      data,
      loader: false,
    },
    (error, response) => {
      if (!error && response?.data?.categoryData) {
        dispatch({
          type: UPDATE_ANALYSIS_DATA,
          payload: {
            data: response.data.categoryData,
            dataType: "frequent"
          }
        })
      }
    }
  )
}

export const getNonFrequentAnalysisData = data => dispatch => {
  fetchDataAndProceed(
    {
      url: API.getNonFrequentData,
      method: METHOD_TYPES.POST,
      data,
      loader: false,
    },
    (error, response) => {
      if (!error && response?.data?.categoryData) {
        dispatch({
          type: UPDATE_ANALYSIS_DATA,
          payload: {
            data: response.data.categoryData,
            dataType: "nonFrequent"
          }
        })
      }
    }
  )
}
